<vwui-form-group class="radio-group" role="radiogroup" [label]="label" [required]="required">
    <ng-container *ngFor="let radioItem of radioItems; trackBy: trackByTitle">
        <vwui-radio [name]="name" (vwuiChecked)="setRadioValue(radioItem.value)" [value]="radioItem.value" [checked]="isChecked(radioItem.value)">{{ radioItem.title | translate}}</vwui-radio>
    </ng-container>
</vwui-form-group>
